import {useState} from 'react'
import '../../../../styles/scss/change-password/change-password.scss'
import * as API_USER from '../../../../shared/http/user'
import {Button, Card, Form, Input, notification, Typography} from 'antd'
import {Helmet} from 'react-helmet'
import {NavigationPages} from '../../../../common/navigation/navigation-pages'
import {goToPageNotPremium} from '../../../utils/goToPage'
import {useNavigate} from 'react-router-dom'

const {Title, Text} = Typography;

const ChangePassword = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm();

    const [submitting, setSubmitting] = useState<boolean>(false);

    const onFinish = async (values: { password: string; confirm: string }) => {
        try {
            const urlParams = new URLSearchParams(window.location.search)

            const token = urlParams.get('token')
            const id = urlParams.get('id')

            if (token && id) {
                setSubmitting(true)
                const passwordDto = {
                    userId: parseInt(id),
                    userToken: token,
                    password: values.password,
                }
                await API_USER.changePassword(passwordDto);
                notification.open({message: 'Пароль успешно изменен'})
                goToPageNotPremium(NavigationPages.LANDING, navigate)
            }
            form.resetFields();
        } catch (e: any) {
            notification.open({message: 'Не удалось изменить пароль'})
        } finally {
            setSubmitting(false);
        }
    };


    return (
        <div
            id="change-password"
            style={{
                minHeight: '100dvh',
                padding: 16,
                display: 'grid',
                placeItems: 'center',
                background:
                    'linear-gradient(135deg, rgba(99,102,241,0.08), rgba(236,72,153,0.08))',
            }}
        >
            <Helmet title="Voxlingua: Смена пароля"/>
            <Card
                style={{width: '100%', maxWidth: 440}}
            >
                <Title level={3} style={{marginBottom: 8}}>
                    Voxlingua
                </Title>
                <Text type="secondary">Смена пароля</Text>

                <Form
                    form={form}
                    layout="vertical"
                    size="large"
                    style={{marginTop: 16}}
                    onFinish={onFinish}
                    requiredMark={false}
                >
                    <Form.Item
                        name="password"
                        label="Новый пароль"
                        rules={[
                            {required: true, message: 'Введите новый пароль'},
                            {min: 6, message: 'Минимум 6 символов'},
                            {max: 20, message: 'Максимум 20 символов'},
                        ]}
                        hasFeedback
                    >
                        <Input.Password
                            placeholder="New password"
                            autoComplete="new-password"
                        />
                    </Form.Item>

                    <Form.Item
                        name="confirm"
                        label="Подтверждение пароля"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {required: true, message: 'Подтвердите пароль'},
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(
                                        new Error('Пароли не совпадают'),
                                    );
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            placeholder="Confirm new password"
                            autoComplete="new-password"
                        />
                    </Form.Item>

                    <Form.Item shouldUpdate>
                        {() => {
                            const hasErrors = form.getFieldsError().some(({errors}) => errors.length);
                            const touched = form.isFieldsTouched(['password', 'confirm'], true);
                            const {password, confirm} = form.getFieldsValue(['password', 'confirm']);
                            const filled = Boolean(password) && Boolean(confirm);

                            return (
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    block
                                    loading={submitting}
                                    disabled={!touched || !filled || hasErrors}
                                >
                                    Сменить пароль
                                </Button>
                            );
                        }}
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}

export default ChangePassword
